var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-menu', {
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": this.$route.path,
      "router": true,
      "collapse": _vm.isCollapse
    }
  }, [_c('div', {
    staticClass: "topSide"
  }, [_c('img', {
    staticClass: "logout",
    attrs: {
      "src": require("../../assets/logo.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _vm._l((_vm.data), function(item, index) {
    return _c('div', {
      key: index
    }, [(item.children) ? _c('el-submenu', {
      attrs: {
        "index": item.path
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: item.icon
    }), _vm._v(" "), _c('span', {
      attrs: {
        "title": item.name
      }
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _vm._l((item.children), function(it, index) {
      return _c('div', {
        key: index
      }, [_c('el-menu-item', {
        attrs: {
          "index": it.path
        }
      }, [_c('span', {
        attrs: {
          "title": it.name
        }
      }, [_vm._v(_vm._s(it.name))])])], 1)
    })], 2) : _c('el-menu-item', {
      attrs: {
        "index": item.path
      }
    }, [_c('i', {
      class: item.icon
    }), _vm._v(" "), _c('span', {
      attrs: {
        "title": item.name
      }
    }, [_vm._v(_vm._s(item.name))])])], 1)
  })], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e7828f7e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/Sidebar.vue
// module id = cAyx
// module chunks = 1